import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CustomerVoiceSection from '@/components/feature/CustomerVoiceSection';
import HeroSection from './components/HeroSection';
import TimelineSection from './components/TimelineSection';
import ProblemSection from './components/ProblemSection';
import ConditionsSection from './components/ConditionsSection';
import MethodSection from './components/MethodSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <TimelineSection />
        <ProblemSection />
        <ConditionsSection />
        <MethodSection />
        <CustomerVoiceSection variant="light" />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
